import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/site/Seo";
import SectionHeading from "@/components/site/SectionHeading";
import { SERVICES } from "@/data/site";
import { beautySalonSchema, breadcrumb } from "@/data/schema";

export default function ServicesIndex() {
  return (
    <>
      <Seo
        title="Services | Lash Extensions, Brows & Beauty - Golden Touch Vero Beach"
        description="Explore Golden Touch Lash & Brow services in Vero Beach, FL: classic, hybrid and volume lash extensions, brow lamination, tint and shaping, plus facials, waxing and beauty treatments."
        path="/services"
        jsonLd={[
          beautySalonSchema(),
          breadcrumb([
            { name: "Home", path: "/" },
            { name: "Services", path: "/services" },
          ]),
        ]}
      />
      <section className="bg-onyx pt-28 md:pt-36 pb-20 md:pb-28">
        <h1 className="sr-only">
          Golden Touch Services - Lash Extensions, Brow Services & Skin Beauty in Vero Beach, FL
        </h1>
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <div className="text-center reveal">
            <p className="eyebrow">What We Offer</p>
            <div className="mt-4">
              <SectionHeading dark>Our Services</SectionHeading>
            </div>
            <p className="mx-auto mt-6 max-w-2xl text-muted-ivory">
              Every service at Golden Touch is tailored to enhance your natural beauty - crafted
              with precision and care in Vero Beach, Florida.
            </p>
          </div>

          <div className="mt-16 space-y-16">
            {SERVICES.map((s, idx) => (
              <div
                key={s.slug}
                className={`reveal grid gap-8 lg:grid-cols-2 lg:items-center ${
                  idx % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
                }`}
              >
                <Link to={`/services/${s.slug}`} className="img-zoom block overflow-hidden rounded-[2rem] border border-gold/15 aspect-[4/3]">
                  <img
                    src={s.image}
                    alt={s.alt}
                    width={1000}
                    height={750}
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-cover"
                  />
                </Link>
                <div>
                  <h3 className="font-display text-3xl md:text-4xl text-ivory">{s.title}</h3>
                  <p className="mt-2 text-[0.72rem] tracking-[0.28em] uppercase text-gold">
                    {s.tagline}
                  </p>
                  <p className="mt-5 text-base leading-relaxed text-muted-ivory">{s.short}</p>
                  <div className="mt-8 flex flex-wrap gap-3">
                    <Link
                      to={`/services/${s.slug}`}
                      className="btn-gold-outline px-7 py-3 text-[0.7rem] tracking-[0.24em] uppercase"
                    >
                      Learn More
                    </Link>
                    <Link
                      to={s.bookAllCategories ? "/book" : `/book?category=${encodeURIComponent(s.acuityCategory)}`}
                      className="btn-gold px-7 py-3 text-[0.7rem] tracking-[0.24em] uppercase"
                    >
                      Book Now
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
